import React from 'react';
import styles from './LandingPage.module.css';

const features = [
  {
    title: 'Unlimited AI Voice Agents',
    description: 'Scale operations without limits. Easily oversee and control numerous client accounts from a single, centralized dashboard.',
  },
  {
    title: 'Dynamic Interface',
    description: 'Rebrand the entire functionality with your agency’s logo, colors, and domain for a seamless client experience.',
  },
  {
    title: 'Automated Appointment Booking',
    description: 'Streamline scheduling with AI-powered booking capabilities.',
  },
  {
    title: 'Call Recording & Transcription',
    description: 'Capture and convert every conversation for easy reference.',
  },
  {
    title: 'Superior Noise Reduction',
    description: 'Ensure crystal-clear communication with advanced audio processing.',
  },
  {
    title: 'Train AI in 10 Seconds',
    description: 'Quickly customize AI behavior using existing call recordings or a pre-built script.',
  },
];

const LandingPage = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Transform Your Business with AI-Powered Solutions</h1>
      <div className={styles.grid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.card}>
            <h2 className={styles.cardTitle}>{feature.title}</h2>
            <p className={styles.cardDescription}>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingPage;